import { TeamsUserCredential } from '@microsoft/teamsfx';
import { createContext } from 'react';
import { Theme } from '@fluentui/react-components';

export const TeamsFxContext = createContext<{
  theme?: Theme;
  themeString: string;
  teamsUserCredential?: TeamsUserCredential;
  hostName?: string;
  m365MobileAuthenticated?: boolean;
  locale: string;
}>({
  theme: undefined,
  themeString: '',
  teamsUserCredential: undefined,
  hostName: '',
  m365MobileAuthenticated: false,
  locale: '',
});
